import React, {useEffect, useState} from 'react';
import axios from 'axios';
import * as config from '../../configs/Config';
import {adaptUser, loadAuth, persistAuth} from '../../libraries/Authentication';
import {exchangeSpotifyCode} from '../../libraries/SpotifyAuth';

/**
 * Lands here from accounts.spotify.com with ?code=. Exchanges it for tokens
 * (stored for the Web Playback SDK), then signs the user in via the backend —
 * unless a session already exists, in which case the Spotify grant just
 * becomes the playback link for the current account (no session switch).
 */
export default function SpotifyCallback() {
    const [message, setMessage] = useState('Connecting your Spotify account…');

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        if (!code) {
            setMessage(params.get('error') === 'access_denied'
                ? 'Spotify sign-in was cancelled.'
                : 'Spotify sign-in failed.');
            setTimeout(() => { window.location.pathname = '/login'; }, 1500);
            return;
        }
        (async () => {
            try {
                const accessToken = await exchangeSpotifyCode(code);
                if (!loadAuth()) {
                    const {data} = await axios.post(`${config.API_URL}/auth/spotify`, {
                        access_token: accessToken,
                    }, {headers: {Accept: 'application/json'}});
                    persistAuth(data.token, adaptUser(data.user));
                }
                window.location.replace('/');
            } catch (e) {
                setMessage('Spotify sign-in failed. Please try again.');
                setTimeout(() => { window.location.pathname = '/login'; }, 2000);
            }
        })();
    }, []);

    return (
        <div className="flex h-screen items-center justify-center text-gray-500">
            {message}
        </div>
    );
}
